import * as tslib_1 from "tslib";
// Core packages
import { OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
// Third party packages
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
// Custom packages
import { AuthService } from 'src/app/modules/auth/auth.service';
import { CompaniesService } from 'src/app/modules/companies/companies.service';
import { PropertiesService } from "src/app/modules/properties/properties.service";
import { AddCommunicationDialogComponent } from 'src/app/shared/components/dialogs/add-communication-dialog/add-communication-dialog.component';
import { PhonebookContact } from 'src/app/shared/models/phonebook/phonebook.model';
import { ConfigService } from 'src/app/shared/services/config.service';
import { HelperService } from 'src/app/shared/services/helper.service';
var EditPhonebookContactDialogComponent = /** @class */ (function () {
    /**
     * Class constructor
     */
    function EditPhonebookContactDialogComponent(dialogRef, data, newMessagedialogRef, newMessageDialog, configService, cookieService, toastrService, translateService, companiesService, authService, helperService, propertiesService) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.newMessagedialogRef = newMessagedialogRef;
        this.newMessageDialog = newMessageDialog;
        this.configService = configService;
        this.cookieService = cookieService;
        this.toastrService = toastrService;
        this.translateService = translateService;
        this.companiesService = companiesService;
        this.authService = authService;
        this.helperService = helperService;
        this.propertiesService = propertiesService;
        this.subscriptions = [];
        this.phonebook = new PhonebookContact()[''];
        this.lang = this.translateService.currentLang || this.translateService.defaultLang;
        // BEGIN - Edit phonebook contact form
        // BEGIN - ngx-formly
        this.form = new FormGroup({});
        this.model = {};
        this.fields = [];
        this.options = {};
        // END - ngx-formly
        this.formBtnOptions = {
            active: false,
            text: this.translateService.instant('common.cta.save'),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: 'primary',
            spinnerColor: 'primary',
            fullWidth: false,
            disabled: false,
            mode: 'indeterminate',
            buttonIcon: {
                fontSet: 'fal',
                fontIcon: 'fa-save',
                inline: true,
            },
        };
        // END - Edit phonebook contact form
        this.createdAt = "";
        this.dialogIsLoading = true;
        this.propertiesMaster = [];
    }
    /**
     * Init component
     *
     */
    EditPhonebookContactDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Get logged user data
        this.subscriptions.push(this.authService.loggedUser$.subscribe(function (res) { return _this.loggedUser = res; }));
        this.subscriptions.push(this.authService.loggedUserPermissions$.subscribe(function (res) { return _this.loggedUserPermissions = res; }));
        // Get current lang
        this.lang = this.cookieService.get('lang') || this.configService.defaultLang;
        this.authService.loggedUserRequestedRoleType$.subscribe(function (res) {
            if (res) {
                _this.loggedUserRoleType = res;
                if (_this.loggedUserRoleType === "master" ||
                    _this.loggedUserRoleType === "collaborator") {
                    _this.subscriptions.push(_this.propertiesService.getPropertiesMaster().subscribe(function (res) {
                        if (res.status) {
                            _this.propertiesMaster = res.data.items;
                            // Init add form
                            _this.initMasterForm();
                        }
                        _this.dialogIsLoading = false;
                    }, function (err) {
                        _this.dialogIsLoading = false;
                    }));
                }
                else if (_this.loggedUserRoleType === "admin" ||
                    _this.loggedUserRoleType === "operator") {
                    _this.initForm();
                    _this.dialogIsLoading = false;
                }
            }
        });
    };
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    EditPhonebookContactDialogComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    /**
     * Init form
     *
     * @since 1.0.0
     */
    EditPhonebookContactDialogComponent.prototype.initMasterForm = function () {
        // Set model (shallow clone to avoid mutating the table row element passed by reference)
        this.model = Object.assign({}, this.data.phonebookContact);
        this.createdAt = this.data.phonebookContact.createdAt;
        if (this.data.phonebookContact.propertyId &&
            this.data.phonebookContact.propertyId._id) {
            this.model.propertyId = this.data.phonebookContact.propertyId._id;
        }
        var propertiesOption = [];
        propertiesOption.push({
            label: '',
            value: '',
        });
        if (this.propertiesMaster && Array.isArray(this.propertiesMaster)) {
            this.propertiesMaster.forEach(function (item) {
                return propertiesOption.push({
                    label: item.name,
                    value: item._id,
                });
            });
        }
        // Set fields
        this.fields = tslib_1.__spread(this.fields, [
            {
                fieldGroupClassName: 'row',
                fieldGroup: [
                    {
                        className: 'col-12 col-md-3',
                        type: 'input',
                        key: 'firstName',
                        templateOptions: {
                            label: this.translateService.instant('companies.fields.phonebook.firstName'),
                            placeholder: this.translateService.instant('companies.fields.phonebook.firstName'),
                            required: true,
                            minLength: 2,
                            maxLength: 50,
                        },
                    },
                    {
                        className: 'col-12 col-md-3',
                        type: 'input',
                        key: 'lastName',
                        templateOptions: {
                            label: this.translateService.instant('companies.fields.phonebook.lastName'),
                            placeholder: this.translateService.instant('companies.fields.phonebook.lastName'),
                            required: true,
                            minLength: 2,
                            maxLength: 50,
                        },
                    },
                    {
                        className: 'col-12 col-md-6',
                        type: 'select',
                        key: 'propertyId',
                        templateOptions: {
                            label: this.translateService.instant('companies.fields.phonebook.property'),
                            placeholder: this.translateService.instant('companies.fields.phonebook.property'),
                            required: false,
                            options: propertiesOption,
                        },
                    },
                    {
                        className: 'col-12 col-md-3',
                        type: 'input',
                        key: 'subui',
                        templateOptions: {
                            label: this.translateService.instant('companies.fields.phonebook.subUI'),
                            placeholder: this.translateService.instant('companies.fields.phonebook.subUI'),
                            required: false,
                            minLength: 0,
                            maxLength: 100,
                        },
                    },
                    {
                        className: 'col-12 col-md-3',
                        type: 'select',
                        key: 'type',
                        templateOptions: {
                            label: this.translateService.instant('companies.fields.phonebook.type'),
                            placeholder: this.translateService.instant('companies.fields.phonebook.type'),
                            required: false,
                            options: [
                                {
                                    label: this.translateService.instant('properties.fields.phonebook.councilor'),
                                    value: 'councilor',
                                },
                                {
                                    label: this.translateService.instant('properties.fields.phonebook.occupant'),
                                    value: 'occupant',
                                },
                                {
                                    label: this.translateService.instant('properties.fields.phonebook.provider'),
                                    value: 'provider',
                                },
                            ]
                        },
                    },
                    {
                        className: 'col-12',
                        type: 'input',
                        key: 'email',
                        templateOptions: {
                            type: 'email',
                            label: this.translateService.instant('companies.fields.phonebook.email'),
                            placeholder: this.translateService.instant('companies.fields.phonebook.email'),
                            required: false,
                            minLength: 6,
                            maxLength: 320,
                        },
                    },
                    {
                        className: 'col-12 col-md-6',
                        type: 'input',
                        key: 'phone',
                        templateOptions: {
                            label: this.translateService.instant('companies.fields.phonebook.phone'),
                            placeholder: this.translateService.instant('companies.fields.phonebook.phone'),
                            required: false,
                            minLength: 0,
                            maxLength: 50,
                        },
                    },
                    {
                        className: 'col-12 col-md-6',
                        type: 'input',
                        key: 'mobile',
                        templateOptions: {
                            label: this.translateService.instant('companies.fields.phonebook.mobile'),
                            placeholder: this.translateService.instant('companies.fields.phonebook.mobile'),
                            required: false,
                            minLength: 0,
                            maxLength: 50,
                        },
                    },
                    {
                        className: 'col-12',
                        type: 'textarea',
                        key: 'notes',
                        templateOptions: {
                            label: this.translateService.instant('companies.fields.phonebook.notes'),
                            placeholder: this.translateService.instant('companies.fields.phonebook.notes'),
                            required: false,
                            maxLength: 1000,
                            rows: 2,
                        },
                        expressionProperties: {
                            'templateOptions.description': '(model[field.key]||"").length+"/" +field.templateOptions.maxLength',
                        }
                    },
                ],
            },
        ]);
    };
    /**
     * Init form
     *
     * @since 1.0.0
     */
    EditPhonebookContactDialogComponent.prototype.initForm = function () {
        // Set model (shallow clone to avoid mutating the table row element passed by reference)
        this.model = Object.assign({}, this.data.phonebookContact);
        this.createdAt = this.data.phonebookContact.createdAt;
        // Set fields
        this.fields = tslib_1.__spread(this.fields, [
            {
                fieldGroupClassName: 'row',
                fieldGroup: [
                    {
                        className: 'col-12 col-md-3',
                        type: 'input',
                        key: 'firstName',
                        templateOptions: {
                            label: this.translateService.instant('companies.fields.phonebook.firstName'),
                            placeholder: this.translateService.instant('companies.fields.phonebook.firstName'),
                            required: true,
                            minLength: 2,
                            maxLength: 50,
                        },
                    },
                    {
                        className: 'col-12 col-md-3',
                        type: 'input',
                        key: 'lastName',
                        templateOptions: {
                            label: this.translateService.instant('companies.fields.phonebook.lastName'),
                            placeholder: this.translateService.instant('companies.fields.phonebook.lastName'),
                            required: true,
                            minLength: 2,
                            maxLength: 50,
                        },
                    },
                    {
                        className: 'col-12 col-md-3',
                        type: 'input',
                        key: 'subui',
                        templateOptions: {
                            label: this.translateService.instant('companies.fields.phonebook.subUI'),
                            placeholder: this.translateService.instant('companies.fields.phonebook.subUI'),
                            required: false,
                            minLength: 0,
                            maxLength: 100,
                        },
                    },
                    {
                        className: 'col-12 col-md-3',
                        type: 'select',
                        key: 'type',
                        templateOptions: {
                            label: this.translateService.instant('companies.fields.phonebook.type'),
                            placeholder: this.translateService.instant('companies.fields.phonebook.type'),
                            required: false,
                            options: [
                                {
                                    label: this.translateService.instant('properties.fields.phonebook.councilor'),
                                    value: 'councilor',
                                },
                                {
                                    label: this.translateService.instant('properties.fields.phonebook.occupant'),
                                    value: 'occupant',
                                },
                                {
                                    label: this.translateService.instant('properties.fields.phonebook.provider'),
                                    value: 'provider',
                                },
                            ]
                        },
                    },
                    {
                        className: 'col-12',
                        type: 'input',
                        key: 'email',
                        templateOptions: {
                            type: 'email',
                            label: this.translateService.instant('companies.fields.phonebook.email'),
                            placeholder: this.translateService.instant('companies.fields.phonebook.email'),
                            required: false,
                            minLength: 6,
                            maxLength: 320,
                        },
                    },
                    {
                        className: 'col-12 col-md-6',
                        type: 'input',
                        key: 'phone',
                        templateOptions: {
                            label: this.translateService.instant('companies.fields.phonebook.phone'),
                            placeholder: this.translateService.instant('companies.fields.phonebook.phone'),
                            required: false,
                            minLength: 0,
                            maxLength: 50,
                        },
                    },
                    {
                        className: 'col-12 col-md-6',
                        type: 'input',
                        key: 'mobile',
                        templateOptions: {
                            label: this.translateService.instant('companies.fields.phonebook.mobile'),
                            placeholder: this.translateService.instant('companies.fields.phonebook.mobile'),
                            required: false,
                            minLength: 0,
                            maxLength: 50,
                        },
                    },
                    {
                        className: 'col-12',
                        type: 'textarea',
                        key: 'notes',
                        templateOptions: {
                            label: this.translateService.instant('companies.fields.phonebook.notes'),
                            placeholder: this.translateService.instant('companies.fields.phonebook.notes'),
                            required: false,
                            maxLength: 1000,
                            rows: 2,
                        },
                        expressionProperties: {
                            'templateOptions.description': '(model[field.key]||"").length+"/" +field.templateOptions.maxLength',
                        }
                    },
                ],
            },
        ]);
    };
    /**
     * Handle dialog closing
     *
     * @since 1.0.0
     *
     * @param [data] optional data passed to the caller component
     */
    EditPhonebookContactDialogComponent.prototype.onClose = function (data) {
        this.dialogRef.close(data);
    };
    /**
     * Handle form submit
     *
     * @since 1.0.0
     */
    EditPhonebookContactDialogComponent.prototype.onFormSubmit = function (model) {
        var _this = this;
        // Prevent invalid form submit
        if (this.form.invalid) {
            Object.keys(this.form.controls).forEach(function (key) {
                _this.form.controls[key].markAsTouched();
            });
            this.toastrService.error(this.translateService.instant('common.errors.form_is_invalid'));
            return;
        }
        this.subscriptions.push(this.companiesService.updatePhonebookContact(this.data.companyId, this.data.phonebookContact._id, model)
            .pipe(finalize(function () { return _this.formBtnOptions.active = false; }))
            .subscribe(function (res) {
            if (res.status) {
                _this.toastrService.success(res.message);
                _this.onClose(true);
                return;
            }
            _this.toastrService.error(_this.translateService.instant('common.errors.unknown_server_error'));
        }, function (err) {
            // Choose one of the following error handling method.
            // 1) First one show a message right under the form fields
            //    (if the form is properly setted)
            // 2) Second one is used to show a mat-error under each field
            //    in the dynamic form (is meant to be used only in dynamicForm)
            // 3) Third one show toastr notifications for each error
            // 4) Fourth one is used to show mat-error under each field
            //    in the ngx-formly form (is mean to be used only with ngx-formly)
            // this.helperService.handleFormError(form, err);
            // this.helperService.handleDynamicFormError(form, err);
            // this.helperService.handleError(err);
            _this.helperService.handleFormlyError(_this.form, err);
        }));
    };
    /**
     * Handle new message dialog open
     *
     * @since 1.0.0
     */
    EditPhonebookContactDialogComponent.prototype.onAddCommunication = function () {
        var _this = this;
        if (!this.model) {
            return;
        }
        // First get phonebook list from company
        this.subscriptions.push(this.companiesService.getPhonebookList(this.data.companyId).subscribe(function (res) {
            if (res.status) {
                _this.phonebook = res.data.items;
                // Open dialog
                var newMessageDialogRef = _this.newMessageDialog.open(AddCommunicationDialogComponent, {
                    minWidth: '60%',
                    maxHeight: '98vh',
                    data: {
                        recipients: [{
                                email: _this.model.email,
                                name: _this.model.firstName + " " + _this.model.lastName,
                            }],
                        phonebook: _this.phonebook,
                    },
                    disableClose: true,
                });
                // On dialog closing, check if something is changed
                // If so, let's reload table data
                _this.subscriptions.push(newMessageDialogRef.afterClosed()
                    .subscribe(function (res2) {
                    if (typeof res2 !== 'undefined' && res2.sendedMessage) {
                        _this.toastrService.success(_this.translateService.instant('communications.add.sendedSuccessfully'));
                        return;
                    }
                }, function (err) {
                    _this.helperService.handleError(err);
                }));
            }
        }, function (err) {
            _this.helperService.handleError(err);
        }));
    };
    return EditPhonebookContactDialogComponent;
}());
export { EditPhonebookContactDialogComponent };
